/**
 *
 * ContentView
 *
 */

import React from 'react';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import classnames from 'classnames';

import styles from './styles.module.css';

type ContentViewProps = {
  isLoading?: boolean;
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  floatingActionButton?: React.ReactNode;
  contentWrapperStyle?: React.CSSProperties;
  fullWidth?: boolean;
};

export const ContentView = (props: ContentViewProps) => {
  const {
    header,
    footer,
    children,
    floatingActionButton,
    isLoading = false,
    fullWidth = false,
    contentWrapperStyle,
  } = props;

  return (
    <div className={styles.container}>
      {!!header && <div className={styles.header}>{header}</div>}
      <div className={styles.content} style={contentWrapperStyle}>
        <Paper
          className={classnames(styles['content-paper'], {
            [styles['full-width']]: fullWidth,
          })}
          style={{
            // the paper component has transition: all 450ms by default
            // which will also trigger an animation whenever the content
            // within the view is loaded
            transition: 'none',
            borderRadius: 0,
          }}
        >
          <div
            className={classnames(
              styles['content-wrapper'],
              isLoading && styles.loading,
              { [styles['full-width']]: fullWidth }
            )}
          >
            {isLoading && <CircularProgress size={60} />}
            <div
              className={classnames({ [styles['hide-children']]: isLoading })}
            >
              {children}
            </div>
          </div>
          {!!floatingActionButton && !isLoading && (
            <div className={styles['fab-wrapper']}>
              <div className={styles['floating-action-button']}>
                {floatingActionButton}
              </div>
            </div>
          )}
          {!!footer && (
            <div
              className={styles['footer-wrapper']}
              style={{ borderRadius: 0 }}
            >
              {footer}
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
};

ContentView.displayName = 'ContentView';

export default ContentView;
